var React = require('react');

function MyProfileMyVignetteIcon (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"width":"20","height":"20","style":{"fill":"none"},"key":0}),React.createElement("path",{"id":"road","d":"M16.8,4.3c-.3-1.7-1.8-3-3.6-3h-6.6c-1.8,0-3.3,1.3-3.6,3l-1.8,10.1c-.3,2,1,3.8,2.9,4.2.2,0,.4,0,.6,0h10.1c2,0,3.6-1.6,3.6-3.6,0-.2,0-.4,0-.6l-1.8-10.1ZM16.7,16.5c-.4.5-1,.8-1.7.8H4.9c-1.2,0-2.2-1-2.2-2.2,0-.1,0-.3,0-.4l1.8-10.1c.2-1,1.1-1.8,2.1-1.8h6.6c1.1,0,2,.8,2.1,1.8l1.8,10.1c.1.6,0,1.3-.5,1.8ZM10.7,4.9v1.4c0,.4-.3.7-.7.7s-.7-.3-.7-.7v-1.4c0-.4.3-.7.7-.7s.7.3.7.7ZM10.7,9.3v1.4c0,.4-.3.7-.7.7s-.7-.3-.7-.7v-1.4c0-.4.3-.7.7-.7s.7.3.7.7ZM10.7,13.6v1.4c0,.4-.3.7-.7.7-.4,0-.7-.3-.7-.7v-1.4c0-.4.3-.7.7-.7s.7.3.7.7Z","style":{"fill":"#5b6070"},"key":1})]);
}

MyProfileMyVignetteIcon.defaultProps = {"id":"Layer_1","width":"20","height":"20","version":"1.1","viewBox":"0 0 20 20"};

module.exports = MyProfileMyVignetteIcon;

MyProfileMyVignetteIcon.default = MyProfileMyVignetteIcon;
